import React, { PropsWithChildren } from 'react';
interface Props {
    className?: string;
    width?: number | string;
    height?: number | string;
}
export const SizedBox: React.FC<Props> = ({
    className,
    width = '100%',
    height = 0,
}) => {
    return (
        <div style={{ width: width, height: height }} />
    );
};
